import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

export const animations = [
  trigger('toastState', [
    state(
      'open-top',
      style({ transform: 'translateY(0) scale(1)', opacity: 1 })
    ),
    state(
      'closed-top',
      style({ transform: 'translateY(-100%) scale(0.25)', opacity: 0 })
    ),

    state(
      'open-bottom',
      style({ transform: 'translateY(0) scale(1)', opacity: 1 })
    ),
    state(
      'closed-bottom',
      style({ transform: 'translateY(100%) scale(0.25)', opacity: 0 })
    ),

    transition('closed-top => open-top', [animate('200ms ease-in')]),
    transition('open-top => closed-top', [animate('150ms ease-out')]),

    transition('closed-bottom => open-bottom', [animate('200ms ease-in')]),
    transition('open-bottom => closed-bottom', [animate('150ms ease-out')])
  ])
];
